export const LOGIN_ROUTE = "/login";
export const CONSULTATIONS_ROUTE = "/consultation";
export const ACTUALS_ROUTE = "/actuals";
export const CHAT_ROUTE = "/chat";
export const MANAGERS_ROUTE = "/managers";
export const STATISTICS_ROUTE = "/statistics";

export const URL = process.env.REACT_APP_API_URL;
